import { Heading } from '@dittolive/anvil'
import { Container } from 'components/layout'

import { useEmployeeGroupContext } from './context'

export default function EmployeeGroupHeader() {
  const { name } = useEmployeeGroupContext()

  return (
    <div className="bg-background">
      <Container>
        <div className="flex flex-col justify-between pb-6 pt-4 lg:flex-row">
          <div className="mb-4 lg:mb-0">
            <Heading level={1} data-testid="employee-group-name">
              {name}
            </Heading>
            <p className="text-foreground-subtle font-sans text-base">
              Employee group
            </p>
          </div>
        </div>
      </Container>
    </div>
  )
}
